// extracted by mini-css-extract-plugin
module.exports = {"input":"PasswordInput_input_2eTxI","toggle":"PasswordInput_toggle_1wRmq"};